import React from 'react';

import FancyLegend from '../../components/vis/FancyLegend';
import {getTextColor} from '../../util/colors';
import {Scalar} from '../../util/plotHelpers/types';
import * as Run from '../../util/runs';

interface ScalarChartProps {
  data: Scalar | null;
  showLegend?: boolean;
  groupArea?: 'none' | 'minmax' | 'stddev' | 'stderr' | 'samples';
}

const ScalarChart: React.FC<ScalarChartProps> = React.memo(
  ({data, showLegend, groupArea}) => {
    return (
      <div className="scalar-values" data-test="scalar-values">
        {data && (
          <div className="scalar-values-inner">
            {data.key != null && showLegend && (
              <div
                className="scalar-legend night-aware"
                style={{
                  color: getTextColor(data.color),
                }}>
                <FancyLegend {...data.key} />
              </div>
            )}
            <div className="scalar-value">
              {Run.prettyNumber(data.value ?? 0)}
            </div>
            {groupArea === 'minmax' && data.range != null && (
              <div>
                ({Run.prettyNumber(data.range[0])},{' '}
                {Run.prettyNumber(data.range[1])})
              </div>
            )}
            {groupArea === 'stddev' && data.stddev != null && (
              <div>{Run.prettyNumber(data.stddev)}</div>
            )}
            {groupArea === 'stderr' && data.stderr != null && (
              <div>{Run.prettyNumber(data.stderr)}</div>
            )}
          </div>
        )}
      </div>
    );
  }
);

export default ScalarChart;
